/**
 * Merge `flywheel_enabled` into the org's serialized `settings`.
 *
 * `settings` is a JSON *string* on the wire, and the single-org and org-list
 * queries both read it off the same normalized entity — so the merged value
 * has to stay a string. Spreading the raw value instead writes an object of
 * character indices, which the list reads as-is and the detail query silently
 * drops when JSON.parse throws.
 *
 * Exported for tests.
 */
export const mergeFlywheelSetting = (existing: unknown, enabled: boolean): string => {
  let parsed: Record<string, unknown> = {};
  if (typeof existing === 'string' && existing) {
    try {
      const decoded: unknown = JSON.parse(existing);
      // A JSON string can decode to a scalar or an array; neither is a settings
      // object, and spreading either would corrupt the result all over again.
      if (decoded && typeof decoded === 'object' && !Array.isArray(decoded)) {
        parsed = decoded as Record<string, unknown>;
      }
    } catch {
      parsed = {};
    }
  }
  return JSON.stringify({ ...parsed, flywheel_enabled: enabled });
};
